var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("pacs008.transaction_list_SCT") } },
    [
      _c("template", { slot: "pageContent" }, [
        _vm.isSmartphoneOS
          ? _c("div", { attrs: { slot: "fixed" }, slot: "fixed" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "44px",
                    width: "100%",
                  },
                },
                [
                  _c("cm-messages-filter", {
                    staticClass: "researchfilter",
                    staticStyle: { position: "relative", "z-index": "10" },
                    attrs: {
                      propedServiceId: "10",
                      filterType: "list",
                      mode: this.mode,
                    },
                    on: {
                      applyFilter: function ($event) {
                        return _vm.applyFilter($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "listPage", staticStyle: { overflow: "hidden" } },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("div", { staticClass: "requestsList" }, [
                      !_vm.isSmartphoneOS
                        ? _c(
                            "div",
                            [
                              _c("cm-messages-filter", {
                                staticClass: "researchfilter",
                                staticStyle: {
                                  position: "relative",
                                  "z-index": "10",
                                },
                                attrs: {
                                  filterType: "list",
                                  format: "SCT",
                                  mode: this.mode,
                                  propedServiceId: "10",
                                  countResults:
                                    _vm.paginationObject.nbResultsTotal.toString(),
                                },
                                on: {
                                  applyFilter: function ($event) {
                                    return _vm.applyFilter($event)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isSmartphoneOS
                        ? _c("div", { style: _vm.customMobileLayoutStyle })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "justify-content-center" },
                      [
                        _c("b-col", { attrs: { sm: "12" } }, [
                          _c("hr", { staticClass: "w-100" }),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      {
                        staticClass: "form-group justify-content-start m-0 p-0",
                      },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "m-0 p-0",
                            attrs: { sm: "2", cols: "6" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "mr-2 text-left cursor",
                                class: {
                                  "active-tab": _vm.currentTab === "list",
                                  "inactive-tab": _vm.currentTab !== "list",
                                },
                                attrs: { size: "sm" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeCurrentTab("list")
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "fa-duotone fa-file" }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("pacs008.transaction_list")) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass: "m-0 p-0",
                            attrs: { sm: "2", cols: "6" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "mr-2 text-left cursor",
                                class: {
                                  "active-tab": _vm.currentTab === "data",
                                  "inactive-tab": _vm.currentTab !== "data",
                                },
                                attrs: { size: "sm" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeCurrentTab("data")
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-duotone fa-file-lines",
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("pacs008.transaction_details")
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.activateSpinner
                      ? _c("spinner")
                      : _vm.currentTab === "list"
                      ? _c(
                          "div",
                          [
                            _vm.items.length
                              ? _c("b-table", {
                                  staticClass: "mt-3",
                                  attrs: {
                                    hover: "",
                                    responsive: "",
                                    items: _vm.items,
                                    fields: _vm.fields,
                                    selectable: "",
                                    "select-mode": "single",
                                    "sort-by": _vm.sortBy,
                                    "sort-desc": _vm.sortDir,
                                  },
                                  on: {
                                    "row-selected": _vm.showData,
                                    "update:sortBy": function ($event) {
                                      _vm.sortBy = $event
                                    },
                                    "update:sort-by": function ($event) {
                                      _vm.sortBy = $event
                                    },
                                    "update:sortDesc": function ($event) {
                                      _vm.sortDir = $event
                                    },
                                    "update:sort-desc": function ($event) {
                                      _vm.sortDir = $event
                                    },
                                    "head-clicked": _vm.sortTable,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "cell(statut)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-center",
                                                staticStyle: {
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis",
                                                },
                                                attrs: { title: data.value },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class:
                                                      data.item.statusClass,
                                                    attrs: {
                                                      title: data.value,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(data.value))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell()",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-center",
                                                staticStyle: {
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      title: data.value,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(data.value))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    473184322
                                  ),
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center",
                                  },
                                  [
                                    _c("span", { staticClass: "noResult" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("common.no_result")) +
                                          "\n              "
                                      ),
                                    ]),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mt-5" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("cm-pagination", {
                                      attrs: {
                                        maxResultsByPage:
                                          _vm.paginationObject.maxResults,
                                        firstIndex:
                                          _vm.paginationObject.firstIndex,
                                        nbResultsTotal:
                                          _vm.paginationObject.nbResultsTotal,
                                        refreshEvent:
                                          _vm.paginationObject.refresh,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "justify-content-end mt-5" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mt-3",
                                    attrs: { lg: "2", offset: "7" },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.exportList()
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-arrow-up-from-bracket",
                                        }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("pain008.extract_list")
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm.currentTab === "data"
                      ? _c(
                          "div",
                          [
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _vm.canGoPrev
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "text-left",
                                        attrs: { md: "2", cols: "4" },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.navDetails(-1)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-chevrons-left",
                                            }),
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("pain008.previous")
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("b-col", {
                                  staticClass: "d-none d-lg-block",
                                  attrs: { md: "8" },
                                }),
                                _vm._v(" "),
                                _vm.canGoNext
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "text-right",
                                        attrs: { md: "2", cols: "4" },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.navDetails(1)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.$t("pain008.next")) +
                                                "\n                  "
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-chevrons-right",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.transactionData, function (info) {
                              return _c(
                                "div",
                                { key: info.id, staticClass: "container" },
                                [
                                  _c("br"),
                                  _vm._v(" "),
                                  info.refTransaction && info.statut
                                    ? _c(
                                        "b-row",
                                        {
                                          staticClass:
                                            "justify-content-center text-center px-5",
                                        },
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "p-0",
                                              attrs: { md: "6", cols: "12" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "bandeau1" },
                                                [
                                                  _vm._v(
                                                    "\n                    Ref:\n                    "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        info.refTransaction
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "p-0",
                                              attrs: { md: "6", cols: "12" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  class:
                                                    info.statut !== "Transmit"
                                                      ? "bandeau2"
                                                      : "bandeau-success",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(info.statut) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "justify-content-end px-5" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "p-0",
                                          attrs: { md: "6", cols: "12" },
                                        },
                                        [
                                          info.code === "AC01"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "title-label-blue",
                                                  staticStyle: {
                                                    width: "200px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "pacs008.refund_info"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          info.code === "DUPL"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "title-label-blue",
                                                  staticStyle: {
                                                    width: "200px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "pacs008.request_info"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "table",
                                            { staticClass: "table" },
                                            [
                                              _c("tbody", [
                                                info.code
                                                  ? _c("tr", [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                          staticStyle: {
                                                            width: "50%",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "pacs008.reason_desc"
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                          staticStyle: {
                                                            width: "50%",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.findCode(
                                                                  info.code
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                info.returnedAmount
                                                  ? _c("tr", [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                          staticStyle: {
                                                            width: "50%",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "pacs008.amount_refunded"
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                          staticStyle: {
                                                            width: "50%",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                info.returnedAmount +
                                                                  " " +
                                                                  info.returnedCurrency
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                info.compensationAmount
                                                  ? _c("tr", [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                          staticStyle: {
                                                            width: "50%",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "pacs008.compensation_taken_by_bank"
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                          staticStyle: {
                                                            width: "50%",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                info.compensationAmount +
                                                                  " " +
                                                                  info.compensationCurrency
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    {
                                      staticClass:
                                        "justify-content-between text-center",
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { md: "3", cols: "4" } },
                                        [
                                          _c("div", { staticClass: "py-4" }, [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("pacs008.process_date")
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              { staticClass: "bloc-gris p-2" },
                                              [_vm._v(_vm._s(info.processDate))]
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "3", cols: "4" } },
                                        [
                                          _c("div", { staticClass: "py-4" }, [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(_vm.$t("pacs008.amount"))
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            info.amount
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "bloc-gris p-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          info.amount +
                                                            " " +
                                                            info.currency
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "bloc-gris p-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s("-") +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "3", cols: "4" } },
                                        [
                                          _c("div", { staticClass: "py-4" }, [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("pacs008.exec_date")
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              { staticClass: "bloc-gris p-2" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(info.executionDate) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    {
                                      staticClass:
                                        "justify-content-between mx-4",
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "bloc-transaction bloc-in mx-auto mb-3",
                                          attrs: { lg: "3", cols: "12" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "p-3 mt-4" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-center font-weight-bold",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "pacs008.comes_from_file"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              info.protocol === "webservice"
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-center word-break",
                                                    },
                                                    [
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-solid fa-globe",
                                                        attrs: {
                                                          title: info.protocol,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            info.msgIdField
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              info.protocol === "interface"
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-center word-break",
                                                    },
                                                    [
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-solid fa-file-arrow-up",
                                                        attrs: {
                                                          title: info.protocol,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            info.msgIdField
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              info.protocol === "remote folder"
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-center word-break",
                                                    },
                                                    [
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-solid fa-folder-arrow-up",
                                                        attrs: {
                                                          title: info.protocol,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            info.msgIdField
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-center word-break",
                                                    },
                                                    [_vm._v("-")]
                                                  ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "my-auto text-center mb-3",
                                          attrs: { lg: "1", cols: "12" },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa-duotone fa-arrow-right-long text-danger h2",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "d-flex justify-content-around bloc-transaction bloc-info mx-auto mb-3",
                                          attrs: { lg: "3", cols: "12" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "p-3 my-auto" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-center font-weight-bold",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "pacs008.transmitter"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(_vm._s(info.debtorName)),
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(info.debtorBankAccount)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(_vm._s(info.debtorBic)),
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(info.debtorCountry)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(info.debtorAddress)
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "p-3 my-auto" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-center font-weight-bold",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "pacs008.recipient"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(info.creditorName)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    info.creditorBankAccount
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(info.creditorBic)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(info.creditorCountry)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(info.creditorAddress)
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "my-auto text-center mb-3",
                                          attrs: { lg: "1", cols: "12" },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa-duotone fa-arrow-right-long text-info h2",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "bloc-transaction bloc-out mx-auto mb-3",
                                          attrs: { lg: "3", cols: "12" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "p-3 d-flex flex-column",
                                              class:
                                                info.type === "sct_instanea"
                                                  ? "mt-5"
                                                  : "mt-4",
                                            },
                                            [
                                              info.type === "sct_instanea"
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-center font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "pacs008.id_pacs"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-center font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "pacs008.content_in_pacs008"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                              _vm._v(" "),
                                              info.namePacs
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-center word-break",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            info.namePacs
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [_vm._v("-")]
                                                  ),
                                              _vm._v(" "),
                                              info.namePacs &&
                                              info.type !== "sct_instanea"
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      staticClass:
                                                        "align-self-center",
                                                      attrs: {
                                                        variant: "primary",
                                                        size: "sm",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.redirectToFile(
                                                            info.idOut,
                                                            info.namePacs
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "pacs008.view_this_file"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }